import { TaskType, GithubAutomationTask, GithubIntegrationTask, PriceFilterType } from "../..";

import { z } from "zod";

export enum JobConditionType {
  Product = 'product',
}

export const productPriceFilterSchema = z.object({
  type: z.nativeEnum(PriceFilterType),
  prices: z.array(z.string()),
});

export const productJobConditionSchema = z.object({
  type: z.literal(JobConditionType.Product),
  productId: z.string(),
  filters: z.array(productPriceFilterSchema),
});

export const jobConditionSchema = z.discriminatedUnion('type', [productJobConditionSchema]);

const onDemandTaskSchema = z.object({
  type: z.literal(TaskType.GithubIntegration),
  action: z.discriminatedUnion('type', [
    z.object({
      type: z.literal(GithubIntegrationTask.AddMemberToGithubOrganization),
      installationId: z.number(),
      teamIds: z.array(z.number()),
    }),
    z.object({
      type: z.literal(GithubIntegrationTask.RemoveMemberFromGithubOrganization),
      installationId: z.number(),
    }),
  ]),
}) satisfies z.ZodType<Pick<GithubAutomationTask, 'type' | 'action'>>;

export const triggerOnDemandAutomationDtoSchema = z.object({
  tasks: z.array(onDemandTaskSchema),
  conditions: z.array(jobConditionSchema),
});

export type TriggerOnDemandAutomationDto = z.infer<typeof triggerOnDemandAutomationDtoSchema>;
